enum DashboardNavigationLocations {
  DASHBOARD = "DASHBOARD",
  COMMERCIAL_DASHBOARD = "COMMERCIAL_DASHBOARD",
  AGENCE_DASHBOARD = "AGENCE_DASHBOARD",
  COMPLIANCE_DASHBOARD = "COMPLIANCE_DASHBOARD",
  CONFORMITE_DASHBOARD = "CONFORMITE_DASHBOARD",
  // CREATE_ACCOUNT = "CREATE_ACCOUNT",
  PROSPECTS = "PROSPECTS",
  CLIENT_360 = "CLIENT_360",
  PROFIL = "PROFIL",
  ROLES_AND_RIGHTS = "ROLES_AND_RIGHTS",
  NOUVELLE_DEMANDE = "NOUVELLE_DEMANDE",
  CREATE_PROSPECT = "CREATE_PROSPECT",
  CREATE_PROSPECT_PP = "CREATE_PROSPECT_PP",
  CREATE_PROSPECT_PM = "CREATE_PROSPECT_PM",
  ONBOARDING = "ONBOARDING",
  PM_ONBOARDING = "PM_ONBOARDING",
  KYB_CASE_DETAIL = "KYB_CASE_DETAIL",
  KYB_MANDATES = "KYB_MANDATES",
  KYB_CORPORATE_ACCESS = "KYB_CORPORATE_ACCESS",
  KYB_ACCESS_RECERTIFICATION = "KYB_ACCESS_RECERTIFICATION",
  KYB_MONITORING = "KYB_MONITORING",
  KYB_RETENTION = "KYB_RETENTION",
  KYB_PERIMETER = "KYB_PERIMETER",
  KYB_COMPLEMENT_DOCUMENTS = "KYB_COMPLEMENT_DOCUMENTS",
  KYB_SIGNATURE_GRIDS = "KYB_SIGNATURE_GRIDS",
  IDENTITY_REPLACEMENT = "IDENTITY_REPLACEMENT",
  RISK_ENTITY_REFERENTIAL = "RISK_ENTITY_REFERENTIAL",
  COMPLIANCE_L1_REVIEW = "COMPLIANCE_L1_REVIEW",
  COMPLIANCE_L1_REVIEW_DETAIL = "COMPLIANCE_L1_REVIEW_DETAIL",
  COMPLIANCE_P4_VALIDATION = "COMPLIANCE_P4_VALIDATION",
  COMPLIANCE_EDD = "COMPLIANCE_EDD",
  COMPLIANCE_EDD_DETAIL = "COMPLIANCE_EDD_DETAIL",
  PLATFORM_SETTINGS = "PLATFORM_SETTINGS",
  AGENCES = "AGENCES",
}

export default DashboardNavigationLocations;
